<!-- 利用終了ボタン -->
<template>
  <div>
    <button class="finish-button" @click="openDialogBookChangeToUsed">
      利用を終了する（旅行終了）
    </button>
    <DialogBookChangeToUsed ref="DialogBookChangeToUsed" />
  </div>
</template>

<script>
export default {
  name: "BFaceFinishButton",
  methods: {
    // 返金画面へ
    openDialogBookChangeToUsed() {
      this.$refs.DialogBookChangeToUsed.openDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
  .finish-button {
    width: 90%;
    height: 50px;
    border: none;
    border-radius: 30px;
    background-color: #FFB206;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    display: block;
    line-height: 50px;
    text-align: center;
    margin: auto;
        margin-top: 50px;
  }
</style>